<template>
  <div id="electricityPage">
    <div class="screenDateBox">
      <img
        class="screenDateItem"
        v-for="(img, index) in screenDateImgs"
        :key="index"
        :src="img.url"
        @click="screenDatetapAction(index)"
      />
    </div>
    <div class="contentBox">
      <div class="chartCls" v-for="(item, index) in dataSource" :key="index">
        <div class="detailBtnBox">
          <i class="iconfont icon-fanhui2 detailBtn" v-show="item.type == 0 ? false : true" @click="detailTapAction(item.type, item.title)"></i>
        </div>
        <linePointChartComponent :curDateType="screenDateImgs[curSelectedIndex].dateValue" :dataSource="item" :energyType="curEnergyType"></linePointChartComponent>
      </div>
    </div>
  </div>
</template>
<script>
import pathKey from '@/router/routerKey';
import requestObjc from "@/utils/requestObjc";
import { energyDataType, getEnergyType, dateType } from "@/utils/typeParam";
import linePointChartComponent from "@/components/subComponents/linePointChartComponent";
import mainStore from '@/store/storeMain';
import { mapGetters } from 'vuex';

export default {
  name: "electricityPage",
  store: mainStore,
  components: {
    linePointChartComponent
  },
  data() {
    return {
      curEnergyType: energyDataType.electricity,
      curSelectedIndex: 3,
      // curDateType: Number,
      screenDateImgs: [
        {
          url: require("@/assets/year.png"),
          imgUrl: require("@/assets/year.png"),
          imgSelUrl: require("@/assets/year_blue.png"),
          dateValue: dateType.yearType
        },
        {
          url: require("@/assets/month.png"),
          imgUrl: require("@/assets/month.png"),
          imgSelUrl: require("@/assets/month_blue.png"),
          dateValue: dateType.monthType
        },
        {
          url: require("@/assets/day.png"),
          imgUrl: require("@/assets/day.png"),
          imgSelUrl: require("@/assets/day_blue.png"),
          dateValue: dateType.dayType
        },
        {
          url: require("@/assets/hour_blue.png"),
          imgUrl: require("@/assets/hour.png"),
          imgSelUrl: require("@/assets/hour_blue.png"),
          dateValue: dateType.hourType
        }
      ],
      dataSource: [] //数据源
    };
  },
  computed: {
    ...mapGetters({
      curHouseInfo: 'getCurHouseInfo'
    })
  },
  created() {
    this.requestData(dateType.hourType);
  },
  methods: {
    //请求数据
    requestData(timeValue) {
      var gateway = this.curHouseInfo.gatewayId;
      //所有电量参数
      var allElectricityParams = {
        dataType: this.curEnergyType,
        datatimetype: timeValue
      };
      requestObjc
        .requestSystemEnergys(allElectricityParams, gateway)
        .then(res => {
          var data = JSON.parse(JSON.stringify(res.data));
          data.forEach((item, index) => {
            var itemValue = Object();
            itemValue.title = getEnergyType.getType(item.type, this.curEnergyType);
            itemValue.type = item.type;
            //按时间做正序排序
            var arr = item.data;
            arr.sort(function(a, b) {
              if (a.key < b.key) {
                return -1;
              }
              return 1;
            });
            var timeArr = [];
            var dataArr = [];
            arr.forEach(subItem => {
              timeArr.push(subItem.key);
              dataArr.push(subItem.data1);
            });
            itemValue.timeArr = timeArr;
            itemValue.dataArr = dataArr;
            this.dataSource.push(itemValue);
          });
        })
        .catch(error => {
          console.log("所有电量请求错误:" + error);
        });
    },
    //切换时间
    screenDatetapAction(tapIndex) {
      if (this.curSelectedIndex == tapIndex) {
        return;
      }
      this.screenDateImgs[this.curSelectedIndex].url = this.screenDateImgs[
        this.curSelectedIndex
      ].imgUrl;
      this.screenDateImgs[tapIndex].url = this.screenDateImgs[
        tapIndex
      ].imgSelUrl;
      this.curSelectedIndex = tapIndex;
      //重新请求数据
      if (this.dataSource.length != 0) {
        this.$set(this, "dataSource", []);
      }
      // this.$set(this, curDateType, this.screenDateImgs[this.curSelectedIndex].dataValue);
      this.requestData(this.screenDateImgs[tapIndex].dateValue);
    },
    //跳转详情的方法
    detailTapAction(type, title) {
      this.$router.push({
        path: pathKey.energyDetail,
        query: {
          energyType: type,
          energyTitle: title
        }
      });
    }
  }
};
</script>
<style scoped>
#electricityPage {
  width: 85%;
  margin: 0 auto;
}
.screenDateBox {
  width: 100%;
  height: 37px;
  margin-top: 30px;
}
.screenDateItem {
  width: 37px;
  height: 37px;
  float: right;
  margin-left: 29px;
}
.screenDateItem:hover {
  cursor: pointer;
}
.screenDateItem::after {
  clear: both;
}
.contentBox {
  margin: 0px 0px 20px 0px;
  padding: 0px;
  width: 100%;
  display: grid;
  justify-items: space-between;
  grid-template-columns: 1fr 1fr;
}
.chartCls {
  height: 260px;
  overflow: hidden;
  box-shadow: 0px 8px 18px 0px rgba(206,231,255,0.21);
  background-color: white;
  border-radius: 10px;
  margin-top: 20px;
  margin-left: 10px;
  margin-right: 10px;
  padding-bottom: 30px;
}
.detailBtnBox {
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.detailBtn {
  font-size: 20px;
  transform: rotateZ(180deg);
  float: right;
  margin-right: 6px;
  color: #F07878;
}
.detailBtn:hover {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/statusPages/electricityPage.vue